module.exports = __webpack_public_path__ + "img/pro_four_1.b3fb9b7b.jpg";